//
// locale_sl.js
// automatically generated by generateLocalePacks.js
//
import messages from '../../app/javascript/mastodon/locales/sl.json';
import localeData from "react-intl/locale-data/sl.js";
import { setLocale } from '../../app/javascript/mastodon/locales';
setLocale({messages, localeData});
